export default {"src":"/polygon/_next/static/media/exodus.1986508a.svg","height":300,"width":300};